import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { SharedTable } from "../../modules/common/table";
import SharedPagination from "../../modules/common/sharedPagination";
import "./style.css";
import { FetchShopifyOrders } from "../../redux/features/shopifyOrders/shopifyOrdersAction";
import { CommonTable } from "../../modules/common/table/Table";
import { shopifyOrderListColumns } from "../../modules/common/table/columns/_shopifyOrderListColumns";
import { StatusCell } from "../../modules/common/table/columns/StatusCell";
import { TitleCell } from "../../modules/common/table/columns/TitleCell";
import CountdownTimer from "./CountdownTimer";

const ShopifyOrdersPage = () => {
  const dispatch: any = useDispatch();
  const [loading, setLoading] = useState(true);
  const headers = ["name", "sku", "consumedQuantity", "updatedAt"];
  const [currentPage, setCurrentPage] = useState(1);
  const limit = 30;
  const states = useSelector((state: any) => state.shopifyOrderSlice);
  const shopifyOrderList = states?.shopifyOrder || [];
  const totalRecord = states?.totalRecord || 0;
  const totalPages = Math.ceil(totalRecord / limit);


  useEffect(() => {
    const fetchOrders = async () => {
      try {
        await dispatch(FetchShopifyOrders({ page: currentPage, limit }));
      } catch (error) {
        console.error("Failed to fetch orders:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchOrders();
  }, [currentPage, dispatch]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  return (
    <>
      <div className="order-status-container">
        <h2 className="page-title">Ordini Shopify</h2>

        {/* <div className='orderListTable'>
          {loading ? (
            <p className="loading-text">Caricamento ordini...</p>
          ) : shopifyOrderList?.length > 0 ? (
            <CommonTable data={shopifyOrderList} columns={shopifyOrderListColumns} />
          ) : (
            <p className="no-orders">Nessun ordine trovato.</p>
          )}
        </div> */}

        <div className="orderListTable">
          {loading ? (
            <p className="loading-text">Caricamento ordini...</p>
          ) : shopifyOrderList?.length > 0 ? (
            <table className="table custom-table">
              <thead>
                <tr>
                  <th>Order Number</th>
                  <th>Prodotto</th>
                  <th>SKU</th>
                  <th>Quantity</th>
                  <th>Prezzo Di Vendita</th>
                  <th>Margine Previsto</th>
                  <th>Stato</th>
                </tr>
              </thead>
              <tbody>
                {shopifyOrderList.map((order) => {
                  const lineItems = order?.line_items || [];

                  return lineItems.map((item, index) => {
                    const isFirst = index === 0;
                    const isLast = index === lineItems.length - 1;

                    return (
                      <tr
                        key={`${order?.orderNumber}-${index}`}
                        className={isLast ? "order-group-end" : ""}
                      >
                        {isFirst && (
                          <td rowSpan={lineItems.length}>
                            {order?.orderNumber}
                          </td>
                        )}
                        <td>
                          {item?.title ? (
                            <span>
                              {item.title}
                              {item?.variant_title ? <><br /><small style={{ color: "#888" }}>{item.variant_title}</small></> : null}
                            </span>
                          ) : "-"}
                        </td>
                        <td>{item?.sku}</td>
                        <td>{item?.quantity || "1"}</td>
                        <td>{'\u20AC'} {item?.price?.toFixed(2)}</td>
                        <td style={{ color: "green" }}>
                          + {item?.margin?.toFixed(1)}{' '}{'\u20AC'}
                          ({item?.selectedPercentage}%)
                        </td>
                        {/* {isFirst && (
                          <td rowSpan={lineItems.length}>
                            {["pending", "accepted", "prepared"].includes(order?.status) ? (
                              <StatusCell userObj={order} from="Status" />
                            ) : (
                              <TitleCell userObj={order.status} />
                            )}
                          </td>
                        )} */}
                        {isFirst && (
                          <td rowSpan={lineItems?.length}>
                            {order?.status === "pending" ? (
                              <>
                                <StatusCell userObj={order} from="Status" />
                                <CountdownTimer createdAt={order?.createdAt} />
                              </>
                            ) : ["accepted", "prepared"].includes(order?.status) ? (
                              <StatusCell userObj={order} from="Status" />
                            ) : (
                              <TitleCell userObj={order.status} />
                            )}
                          </td>
                        )}

                      </tr>
                    );
                  });
                })}
              </tbody>
            </table>
          ) : (
            <p className="no-orders">Nessun ordine trovato.</p>
          )}
        </div>


        {totalRecord > 10 && <SharedPagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
        />}

      </div>
    </>
  );
};

export default ShopifyOrdersPage;
